import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Loader, LoaderProps } from 'src/legacy/components/Loading';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import * as Colors from 'src/theme/colors';

interface LoadingPageProps {
  message?: string;
  subTitle?: string;
  height?: number;
  htmlID?: string;
}

interface StyleProps {
  height: number;
  fullHeight?: boolean;
}

const useStyles = makeStyles<StyleProps>()((_, props) => ({
  root: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column' as const,
    justifyContent: props.height
      ? ('space-between' as const)
      : ('center' as const),
    alignItems: 'center',
    height: props.height || '100%',
  },
  subTitleText: {
    color: Colors.GraySmall,
  },
}));

export const LoadingPage: React.FC<LoadingPageProps & LoaderProps> = ({
  message = '',
  subTitle = '',
  color,
  height = 0,
  htmlID = 'loading-page',
}) => {
  const { classes } = useStyles({ height });
  return (
    <div id={htmlID} className={classes.root}>
      {message && (
        <BaseTypography fontType="18Medium" align="center">
          {message}
        </BaseTypography>
      )}
      <Loader color={color} />
      {subTitle && (
        <BaseTypography
          className={classes.subTitleText}
          fontType="18Medium"
          align="center"
        >
          {subTitle}
        </BaseTypography>
      )}
      {/* Add empty typography support space-between to center loader to page, only needed when subTitle is not present */}
      {message && !subTitle && (
        <BaseTypography fontType="18Medium" align="center" />
      )}
    </div>
  );
};
